/**
 * Adobe Target activity identifiers used by the registration app.
 *
 * Register an activity here so local dev simulation (src/dev.activities.js) and
 * production reads reference the same activity name. The activity itself is
 * created in the Adobe Target console separately.
 *
 * For more information see:
 *   https://www.familysearch.org/frontier/docs/develop/adobe-target
 */
export default {
  // Marketing opt-in A/B experiment (IDENTITY-3859), run on the provider "Finish Setup" page.
  //   IdentityProviderContinueControl      -> show the email opt-in checkbox during registration
  //   IdentityProviderContinueInterjection -> hide the checkbox; prompt via a post-login interjection
  // Naming follows the Frontier convention: the location is [team]_[page], lowercase with
  // underscores, and names the *page* rather than the experiment so a later test on the same
  // page can reuse it. Experiences are [Team][Page][Variant] in PascalCase and must match the
  // Adobe Target UI and JSON experienceId exactly.
  MARKETING_OPT_IN: {
    location: 'identity_provider_continue',
    control: 'IdentityProviderContinueControl',
    interjection: 'IdentityProviderContinueInterjection',
  },
}
